const BACKEND_URL = window.location.hostname === 'localhost' 
  ? process.env.REACT_APP_BACKEND_URL 
  : window.location.origin;

export const CTASection = () => {
  const handleSignup = () => {
    window.location.href = `${BACKEND_URL}/api/signup/`;
  };

  const handleParentLogin = () => {
    window.location.href = `${BACKEND_URL}/api/parent/`;
  };

  return (
    <section className="cta-section" data-testid="cta-section">
      <div className="cta-container">
        <h2>Ready to Transform Your Tutoring Business?</h2>
        <p>Join hundreds of educators who trust Tutrlink to manage their classes and students.</p>
        <div className="cta-buttons">
          <button className="btn btn-white btn-lg" onClick={handleSignup}>
            <i className="fa-solid fa-rocket"></i>
            Start Free Today
          </button>
          <button className="btn btn-outline-white btn-lg" onClick={handleParentLogin}>
            <i className="fa-solid fa-people-roof"></i>
            Parent Portal
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
